/**
 * 調査票/サーベイステータス
 * @enum {string}
 * @readonly
 * @property {string} DRAFT - 作成中
 * @property {string} ACTIVE - 調査中
 */
export const QuestionGroupStatus = {
  DRAFT: 'DRAFT',
  INVESTIGATING: 'INVESTIGATING',
} as const

/**
 * 調査票/サーベイステータス
 */
export type QuestionGroupStatusType =
  (typeof QuestionGroupStatus)[keyof typeof QuestionGroupStatus]
